export default {
  REQUEST_TREE_FOLDERS_LIST: 'REQUEST_TREE_FOLDERS_LIST',
  REQUEST_TREE_FOLDERS_LIST_SUCCESS: 'REQUEST_TREE_FOLDERS_LIST_SUCCESS',
  REQUEST_TREE_FOLDERS_LIST_FAIL: 'REQUEST_TREE_FOLDERS_LIST_FAIL',

  REQUEST_FOLDERS_TREE: 'REQUEST_FOLDERS_TREE',
  REQUEST_FOLDERS_TREE_SUCCESS: 'REQUEST_FOLDERS_TREE_SUCCESS',
  REQUEST_FOLDERS_TREE_FAIL: 'REQUEST_FOLDERS_TREE_FAIL',
};
